import MachineStatusTab from "@components/LiveFloorViewer/MachineStatusTab";
import SiteDetailsTab from "@components/LiveFloorViewer/SiteDetailsTab";
import React from "react";
import { Tab } from "semantic-ui-react";

const LiveFloorView = () => {
  const panes = [
    {
      key: "Site Details",
      menuItem: "Site Details",
      pane: (
        <Tab.Pane>
          <SiteDetailsTab />
        </Tab.Pane>
      ),
    },
    {
      key: "Machine Status",
      menuItem: "Machine Status",
      pane: (
        <Tab.Pane>
          <MachineStatusTab />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="flex-stretch gs-flex-container-vertical height-100">
      <Tab
        renderActiveOnly={false}
        panes={panes}
        className="flex-stretch gs-flex-container-vertical height-100"
      />
    </div>
  );
};

export default LiveFloorView;
